import React, { useState, useEffect, useCallback } from "react"
import { useNavigate } from "react-router-dom"
import API from "./../../Util/API"
import Carousel from "react-bootstrap/Carousel"

export function CarouselGridCardsComponent({ path, category }) {
	const [isLoaded, setIsLoaded] = useState(false)
	const [items, setItems] = useState([])
	const [itemsToShow, setItemsToShow] = useState([])
	const navigate = useNavigate()
	const api = API()

	const getChunkSize = () => {
		if (typeof window === "undefined") return 4
		const width = window.innerWidth
		if (width < 768) return 1
		if (width < 992) return 2
		return 4
	}

	const updateChunks = useCallback((allItems) => {
		const size = getChunkSize()
		const chunked = []
		for (let i = 0; i < allItems.length; i += size) {
			chunked.push(allItems.slice(i, i + size))
		}
		setItemsToShow(chunked)
	}, [])

	useEffect(() => {
		api
			.get(path)
			.then((response) => {
				setIsLoaded(true)
				const data = Array.isArray(response) ? response : []
				setItems(data)
				updateChunks(data)
			})
			.catch((error) => {
				console.error(error)
				setIsLoaded(true)
			})
	}, [path])

	useEffect(() => {
		const handleResize = () => {
			if (items.length > 0) {
				updateChunks(items)
			}
		}
		window.addEventListener("resize", handleResize)
		return () => window.removeEventListener("resize", handleResize)
	}, [items, updateChunks])

	const navigateToPost = (item) => {
		navigate(`/post/${category}/${item.id}`)
	}

	if (!isLoaded) {
		return (
			<div className="d-flex flex-column align-items-center justify-content-center py-5" style={{ minHeight: "220px" }}>
				<div className="spinner-border text-primary" role="status" style={{ width: "2.5rem", height: "2.5rem" }}>
					<span className="visually-hidden">Carregando...</span>
				</div>
			</div>
		)
	}

	if (itemsToShow.length === 0) {
		return null
	}

	return (
		<Carousel id="carousel-2" interval={5000} indicators={itemsToShow.length > 1}>
			{itemsToShow.map((chunk, chunkIndex) => (
				<Carousel.Item key={chunkIndex}>
					<div className="row px-3 px-md-5 py-3 g-3">
						{chunk.map((item) => (
							<div className="col-12 col-md-6 col-lg-3 item" key={item.id}>
								<div
									className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden text-decoration-none text-reset"
									role="button"
									onClick={() => navigateToPost(item)}
									style={{ cursor: "pointer", transition: "transform 0.2s ease, box-shadow 0.2s ease" }}
									onMouseEnter={(e) => {
										e.currentTarget.style.transform = "translateY(-4px)"
										e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)"
									}}
									onMouseLeave={(e) => {
										e.currentTarget.style.transform = "translateY(0)"
										e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.05)"
									}}
								>
									{item.imageCover && (
										<img src={item.imageCover} alt={item.title} className="card-img-top" style={{ height: "160px", objectFit: "cover" }} />
									)}
									<div className="card-body d-flex flex-column p-3">
										<h5
											className="card-title fw-bold fs-6 mb-2 text-primary"
											style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}
										>
											{item.title}
										</h5>
										<p
											className="card-text text-muted small flex-grow-1"
											style={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}
										>
											{item.abstract || "Sem descrição disponível."}
										</p>
										<div className="mt-2 text-end text-primary fw-semibold small">Ver mais &rarr;</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</Carousel.Item>
			))}
		</Carousel>
	)
}
